// extracted by mini-css-extract-plugin
module.exports =  {"image":"_025a50318d--image--jtHse","parallax":"_025a50318d--parallax--AQE9f","old-image":"_025a50318d--old-image--DnBpO","daily-rent":"_025a50318d--daily-rent--OcGKR"};